import { ColumnsType } from "antd/es/table";
import React, { useContext, useEffect, useState } from "react";
import { CustomerProps } from "../../interfaces/interfaces";
import { Tooltip, Table, Popover, List, Button, Typography, Grid } from "antd";
import { USDollar } from "../../utils/func/currency";
import { TablePaginationConfig } from "antd/lib";
import { FilterValue } from "antd/es/table/interface";
import { FolderOpenOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DataContext from "../../context/DataContext";

const { Link } = Typography;

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  sortOrder?: string;
  filters?: Record<string, FilterValue>;
}

export const CustomerTable = ({
  idClient,
  onSelectOne,
  onChangePage,
  customerByProjectView = false,
}: {
  idClient: string;
  onSelectOne: (record: CustomerProps, idProject?: string) => void;
  onChangePage: (current: number, pageSize: number) => void;
  rowSelection: any;
  customerByProjectView?: boolean;
}) => {
  const { dataLoading, customerByClientPaginated: customers } =
    useContext(DataContext);
  const [tableParams, setTableParams] = useState<TableParams>({});
  const [pageSize, setPageSize] = useState<number>(15);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const { useBreakpoint } = Grid;
  const { xs } = useBreakpoint();
  const navigate = useNavigate();
  console.log(customers);

  useEffect(() => {
    onChangePage(currentPage, pageSize);
  }, [currentPage, pageSize]);

  useEffect(() => {
    setTableParams({
      pagination: {
        pageSize: pageSize,
        showSizeChanger: true,
        pageSizeOptions: ["10", "25", "50", "100"],
        showTotal: (total) => `Total ${total} Customers`,
        position: ["bottomCenter"],
        total: parseInt(customers.pagination?.total) || 0,
        onChange: (page, pageSize) => {
          setCurrentPage(page);
          setTableParams((prev) => {
            return {
              ...prev,
              pagination: {
                ...prev.pagination,
                pageSize: pageSize,
              },
            };
          });
          setPageSize(pageSize);
        },
      },
    });
  }, [customers.pagination]);

  const getProjectList = (customer: CustomerProps) => {
    return (
      <List
        dataSource={customer.Projects}
        renderItem={(item) => (
          <div>
            <Button
              type="link"
              size="small"
              onClick={() => onSelectOne(customer, item.id._id)}
            >
              {item.id.name}
            </Button>
          </div>
        )}
      />
    );
  };

  const columns: ColumnsType<CustomerProps> = [
    {
      title: "Client",
      dataIndex: "DisplayName",
      key: "DisplayName",
      className: "table-row",
      width: xs ? "20%" : "30%",
      minWidth: xs ? 100 : 200,
      render: (_, { DisplayName }) => (
        <Tooltip title="Click to see Customer Info" placement="left">
          <Link style={xs ? { fontSize: "12px" } : {}}>{DisplayName}</Link>
        </Tooltip>
      ),
      onCell: (record, index) => {
        return {
          onClick: () => onSelectOne(record, undefined),
        };
      },
      sorter: {
        compare: (a, b) => a.DisplayName.localeCompare(b.DisplayName),
        multiple: 1,
      },

      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Email",
      dataIndex: "PrimaryEmailAddr",
      key: "PrimaryEmailAddr",
      className: "table-row",
      render: (_, { PrimaryEmailAddr }) => (
        <>{PrimaryEmailAddr ? PrimaryEmailAddr.Address : ""}</>
      ),
      sorter: {
        compare: (a, b) =>
          (a.PrimaryEmailAddr?.Address || "").localeCompare(
            b.PrimaryEmailAddr?.Address || "",
          ),
        multiple: 1,
      },

      ellipsis: {
        showTitle: false,
      },
      responsive: ["xl", "lg"],
      hidden: customerByProjectView,
    },
    {
      title: "Phone",
      dataIndex: "PrimaryPhone",
      key: "PrimaryPhone",
      className: "table-row",
      render: (_, { PrimaryPhone }) => <>{PrimaryPhone?.FreeFormNumber}</>,
      sorter: {
        compare: (a, b) =>
          (a.PrimaryPhone?.FreeFormNumber || "").localeCompare(
            b.PrimaryPhone?.FreeFormNumber || "",
          ),
        multiple: 1,
      },

      ellipsis: {
        showTitle: false,
      },
      responsive: ["xl", "lg"],
      hidden: customerByProjectView,
    },
    {
      title: "Projects",
      dataIndex: "projects",
      key: "Projects",
      minWidth: 60,
      className: "table-row align-center pointer",
      render: (_, row) => (
        <Popover content={getProjectList(row)} title="Projects">
          <Link>{row.Projects?.length}</Link>
        </Popover>
      ),
      sorter: {
        compare: (a, b) =>
          (a.Projects?.length || 0) - (b.Projects?.length || 0),
        multiple: 5,
      },
      responsive: ["xl", "lg", "md"],
      hidden: customerByProjectView,
    },
    {
      title: "Balance",
      dataIndex: "Balance",
      key: "Balance",
      className: "align-right table-row",
      render: (_, { Balance }) => (
        <div
          style={{
            color: Balance && Balance > 0 ? "red" : "green",
            fontWeight: 1000,
            textAlign: "right",
          }}
        >
          {USDollar.format(Balance || 0)}
        </div>
      ),
      sorter: {
        compare: (a, b) => a.Balance - b.Balance,
        multiple: 2,
      },

      ellipsis: {
        showTitle: false,
      },
      responsive: ["xl", "lg", "md"],
    },
    {
      title: "Details",
      key: "edit",
      className: "align-center table-row",
      width: "5%",
      minWidth: 70,
      render: (params) => (
        <Tooltip title="Open Client Details" placement="top">
          <Button
            onClick={() =>
              navigate(`/customer-detail/${idClient}/${params._id}`)
            }
            size="small"
            icon={<FolderOpenOutlined />}
          ></Button>
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      bordered
      columns={columns}
      // rowSelection={rowSelection}
      dataSource={customers.data}
      pagination={tableParams.pagination}
      loading={dataLoading}
      size="small"
      rowKey={"Id"}
      scroll={{ y: "70vh", x: "100%" }}
      tableLayout="auto"
    />
  );
};
